import Tool from '../../common/tool';
import WmRequest from '../../common/request';
import SearchResultAppPicker from '../search/searchResultAppPicker';
import { renderHelpArticleProductCard } from './renderHelpArticleProductCard';
import { pickRandomHotContentItems, renderHelpHotContentCard, } from './renderHelpHotContentCard';
import { renderSearchManualList } from '../search/renderSearchManualCard';
import { initProcenterDownloadButtons } from '../procenter/procenterDownload';
function parseListPage(segment) {
    var match = segment.match(/^list_(\d+)\.html$/);
    return match ? Math.max(1, parseInt(match[1], 10)) : 1;
}
function parseRoute(pathname) {
    var _a, _b;
    var parts = pathname.replace(/^\/+|\/+$/g, '').split('/').filter(Boolean);
    var route = {
        classify: 'article',
        productAlias: '',
        page: 1,
        isManual: false,
    };
    if (parts[0] === 'support' && parts[1] === 'manual') {
        route.isManual = true;
        route.classify = 'manual';
        if (parts[2]) {
            if (parts[2].startsWith('list_')) {
                route.page = parseListPage(parts[2]);
            }
            else {
                route.productAlias = parts[2];
                if ((_a = parts[3]) === null || _a === void 0 ? void 0 : _a.startsWith('list_')) {
                    route.page = parseListPage(parts[3]);
                }
            }
        }
        return route;
    }
    route.classify = parts[0] || 'article';
    if (parts[1]) {
        if (parts[1].startsWith('list_')) {
            route.page = parseListPage(parts[1]);
        }
        else {
            route.productAlias = parts[1];
            if ((_b = parts[2]) === null || _b === void 0 ? void 0 : _b.startsWith('list_')) {
                route.page = parseListPage(parts[2]);
            }
        }
    }
    return route;
}
var HelpArticleInfoMain = /** @class */ (function () {
    function HelpArticleInfoMain() {
        var _this = this;
        this.searchURLObj = {};
        this.hotContentPool = [];
        this.hotContentShuffleBound = false;
        this.searchBoxDom = document.getElementById('help-article-search');
        this.listRoot = document.getElementById('help-article-list');
        this.route = parseRoute(decodeURIComponent(window.location.pathname));
        this.pageClassify = document.body.getAttribute('data-classify') || this.route.classify;
        this.wmRequest = new WmRequest();
        this.appPicker = new SearchResultAppPicker(function (gId) {
            var productAlias = gId ? _this.appPicker.getProductAliasForGid(gId) : null;
            window.location.href = _this.buildPageUrl({
                productAlias: productAlias || null,
                page: 1,
            });
        }, function () { return _this.renderProductSidebar(); });
        this.init();
    }
    HelpArticleInfoMain.prototype.init = function () {
        this.parseQuery();
        this.syncSearchInput();
        this.handleSearch();
        this.bindSubClassifyTabs();
        this.initSubClassifyTabArrows();
        this.initManualListIfNeeded();
        this.toggleEmptyState();
        this.initPagination();
        this.loadHotContentSidebar();
        if (this.route.productAlias) {
            this.appPicker.syncFromProductAlias(this.route.productAlias);
        }
        else if (this.searchURLObj.g_id) {
            this.appPicker.syncFromUrl(this.searchURLObj.g_id);
        }
        else {
            this.appPicker.syncFromUrl('');
        }
        this.scheduleProductSidebarRetry();
    };
    /** 等待 productcenterApi 返回后渲染侧栏产品卡（最多约 3 秒） */
    HelpArticleInfoMain.prototype.scheduleProductSidebarRetry = function (retry) {
        var _this = this;
        if (retry === void 0) { retry = 0; }
        this.renderProductSidebar();
        if (this.appPicker.getSelectedProduct() || retry >= 15) {
            return;
        }
        if (!this.route.productAlias && !this.searchURLObj.g_id) {
            return;
        }
        window.setTimeout(function () { return _this.scheduleProductSidebarRetry(retry + 1); }, 200);
    };
    HelpArticleInfoMain.prototype.parseQuery = function () {
        var _this = this;
        var params = new URLSearchParams(window.location.search);
        this.searchURLObj = {};
        params.forEach(function (val, key) {
            _this.searchURLObj[key] = val;
        });
    };
    HelpArticleInfoMain.prototype.syncSearchInput = function () {
        var inputDom = Tool.$_select(this.searchBoxDom, '.search-input');
        if (this.searchURLObj.keywords) {
            inputDom.value = decodeURIComponent(this.searchURLObj.keywords);
        }
    };
    HelpArticleInfoMain.prototype.buildPageUrl = function (opts) {
        var _a, _b, _c;
        var classify = (_a = opts === null || opts === void 0 ? void 0 : opts.classify) !== null && _a !== void 0 ? _a : this.route.classify;
        var page = (_c = (_b = opts === null || opts === void 0 ? void 0 : opts.page) !== null && _b !== void 0 ? _b : this.route.page) !== null && _c !== void 0 ? _c : 1;
        var productAlias = (opts === null || opts === void 0 ? void 0 : opts.productAlias) !== undefined ? opts.productAlias : this.route.productAlias;
        var base = classify === 'manual' ? '/support/manual' : "/".concat(classify);
        if (productAlias) {
            base += "/".concat(productAlias);
        }
        if (page > 1) {
            base += "/list_".concat(page, ".html");
        }
        var params = new URLSearchParams();
        var keywords = (opts === null || opts === void 0 ? void 0 : opts.keywords) !== undefined ? opts.keywords : this.searchURLObj.keywords;
        var subClassify = (opts === null || opts === void 0 ? void 0 : opts.subClassify) !== undefined ? opts.subClassify : this.searchURLObj.sub_classify;
        if (keywords) {
            params.set('keywords', keywords);
        }
        if (subClassify && classify !== 'question') {
            params.set('sub_classify', subClassify);
        }
        var qs = params.toString();
        return qs ? "".concat(base, "?").concat(qs) : base;
    };
    HelpArticleInfoMain.prototype.handleSearch = function () {
        var _this = this;
        var inputDom = Tool.$_select(this.searchBoxDom, '.search-input');
        var searchBtn = Tool.$_select(this.searchBoxDom, '.search-btn');
        var goSearch = function () {
            var keyword = inputDom.value.trim();
            if (!keyword) {
                alert('关键词不能为空！');
                return;
            }
            window.open("/searchResult?keywords=".concat(encodeURIComponent(keyword), "&tab=").concat(_this.pageClassify === 'question' ? 'question' : 'course', "&page=1"));
        };
        searchBtn.addEventListener('click', goSearch);
        inputDom.addEventListener('keydown', function (event) {
            if (event.key === 'Enter') {
                goSearch();
            }
        });
    };
    HelpArticleInfoMain.prototype.goSubClassifyTab = function (rawId) {
        var subId = rawId && Number(rawId) > 0 ? rawId : null;
        window.location.href = this.buildPageUrl({
            subClassify: subId,
            page: 1,
        });
    };
    HelpArticleInfoMain.prototype.bindSubClassifyTabs = function () {
        var _this = this;
        var subTabs = Tool.$_selectAll(document.body, '.help-article-sub-tabs__item');
        subTabs.forEach(function (link) {
            link.addEventListener('click', function (e) {
                e.preventDefault();
                _this.goSubClassifyTab(link.getAttribute('data-sub-classify'));
            });
        });
    };
    /** 教程分类左右箭头：切换上一个 / 下一个 Tab（非横向滚动） */
    HelpArticleInfoMain.prototype.initSubClassifyTabArrows = function () {
        var _this = this;
        var viewport = document.getElementById('help-article-sub-tabs-viewport');
        var prevBtn = document.getElementById('help-article-sub-tabs-prev');
        var nextBtn = document.getElementById('help-article-sub-tabs-next');
        var list = viewport === null || viewport === void 0 ? void 0 : viewport.querySelector('.help-article-sub-tabs__list');
        if (!viewport || !prevBtn || !nextBtn || !list) {
            return;
        }
        var getTabs = function () {
            return Array.from(list.querySelectorAll('.help-article-sub-tabs__item'));
        };
        var getActiveIndex = function () { return getTabs().findIndex(function (tab) { return tab.classList.contains('is-active'); }); };
        var syncArrows = function () {
            var tabs = getTabs();
            var activeIndex = getActiveIndex();
            prevBtn.classList.remove('is-hidden');
            nextBtn.classList.remove('is-hidden');
            if (tabs.length <= 1 || activeIndex < 0) {
                prevBtn.classList.add('is-disabled');
                nextBtn.classList.add('is-disabled');
                return;
            }
            prevBtn.classList.toggle('is-disabled', activeIndex <= 0);
            nextBtn.classList.toggle('is-disabled', activeIndex >= tabs.length - 1);
        };
        var navigateByStep = function (step) {
            var tabs = getTabs();
            var activeIndex = getActiveIndex();
            var targetIndex = activeIndex + step;
            if (targetIndex < 0 || targetIndex >= tabs.length) {
                return;
            }
            _this.goSubClassifyTab(tabs[targetIndex].getAttribute('data-sub-classify'));
        };
        prevBtn.addEventListener('click', function () {
            if (!prevBtn.classList.contains('is-disabled')) {
                navigateByStep(-1);
            }
        });
        nextBtn.addEventListener('click', function () {
            if (!nextBtn.classList.contains('is-disabled')) {
                navigateByStep(1);
            }
        });
        var syncIndicator = function () {
            var bar = document.querySelector('.help-article-filter-bar');
            var indicator = document.getElementById('help-article-sub-tabs-indicator');
            var active = list.querySelector('.help-article-sub-tabs__item.is-active');
            if (!bar || !indicator || !active) {
                indicator === null || indicator === void 0 ? void 0 : indicator.classList.add('is-hidden');
                return;
            }
            var barRect = bar.getBoundingClientRect();
            var tabRect = active.getBoundingClientRect();
            var indicatorWidth = Math.min(80, tabRect.width);
            var left = tabRect.left - barRect.left + (tabRect.width - indicatorWidth) / 2;
            indicator.style.width = "".concat(indicatorWidth, "px");
            indicator.style.left = "".concat(Math.max(0, left), "px");
            indicator.classList.remove('is-hidden');
        };
        window.addEventListener('resize', function () {
            syncArrows();
            syncIndicator();
        });
        var active = list.querySelector('.help-article-sub-tabs__item.is-active');
        if (active) {
            active.scrollIntoView({ inline: 'nearest', block: 'nearest' });
        }
        syncArrows();
        syncIndicator();
        requestAnimationFrame(function () {
            syncArrows();
            syncIndicator();
        });
    };
    HelpArticleInfoMain.prototype.initManualListIfNeeded = function () {
        if (!this.route.isManual) {
            return;
        }
        var el = document.querySelector('.php-json');
        if (!el) {
            return;
        }
        try {
            var payload = JSON.parse(el.getAttribute('data-article') || '{}');
            var rows = (payload.data || []);
            var items = rows.map(function (row) {
                var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
                return ({
                    title: String((_a = row.title) !== null && _a !== void 0 ? _a : ''),
                    details: String((_c = (_b = row.page_desc) !== null && _b !== void 0 ? _b : row.details) !== null && _c !== void 0 ? _c : ''),
                    details_url: String((_d = row.details_url) !== null && _d !== void 0 ? _d : ''),
                    create_time: String((_e = row.create_time) !== null && _e !== void 0 ? _e : ''),
                    g_id: row.g_id,
                    i_url: String((_f = row.i_url) !== null && _f !== void 0 ? _f : ''),
                    win32_url: String((_g = row.win32_url) !== null && _g !== void 0 ? _g : ''),
                    win64_url: String((_h = row.win64_url) !== null && _h !== void 0 ? _h : ''),
                    macM1_url: String((_j = row.macM1_url) !== null && _j !== void 0 ? _j : ''),
                    macIntel_url: String((_k = row.macIntel_url) !== null && _k !== void 0 ? _k : ''),
                    android_url: String((_l = row.android_url) !== null && _l !== void 0 ? _l : ''),
                    ios_url: String((_m = row.ios_url) !== null && _m !== void 0 ? _m : ''),
                });
            });
            var keywords = this.searchURLObj.keywords;
            this.listRoot.innerHTML = renderSearchManualList(items, keywords);
            initProcenterDownloadButtons(this.listRoot);
        }
        catch (e) {
            console.warn('[helpArticleInfo] manual list parse failed', e);
        }
    };
    HelpArticleInfoMain.prototype.toggleEmptyState = function () {
        var emptyBox = document.getElementById('help-article-empty');
        var hasItems = this.listRoot.querySelector('.daetool-help-article-card, .daetool-search-result-manual-card');
        if (!hasItems) {
            emptyBox === null || emptyBox === void 0 ? void 0 : emptyBox.classList.add('is-visible');
        }
        else {
            emptyBox === null || emptyBox === void 0 ? void 0 : emptyBox.classList.remove('is-visible');
        }
    };
    HelpArticleInfoMain.prototype.initPagination = function () {
        if (!webInfo || webInfo.last_page <= 1) {
            return;
        }
        if (typeof DaetoolPagination === 'undefined') {
            console.warn('[helpArticleInfo] daetoolPagination.js 未加载');
            return;
        }
        var that = this;
        var el = document.getElementById('pagination');
        if (el) {
            el.innerHTML = '';
        }
        try {
            new DaetoolPagination({
                element: '#pagination',
                type: 2,
                layout: 'home, prev, pager, next, jumper, last',
                pageIndex: webInfo.current_page,
                pageSize: webInfo.per_page,
                pageCount: 5,
                total: webInfo.total,
                singlePageHide: true,
                ellipsis: true,
                disabled: true,
                currentChange: function (index) {
                    window.location.href = that.buildPageUrl({ page: index });
                },
            });
        }
        catch (e) {
            console.warn('[helpArticleInfo] pagination init failed', e);
        }
    };
    HelpArticleInfoMain.prototype.renderProductSidebar = function () {
        var container = document.getElementById('help-article-product-card');
        if (!container) {
            return;
        }
        var product = this.appPicker.getSelectedProduct();
        if (!product) {
            container.classList.add('is-hidden');
            container.innerHTML = '';
            return;
        }
        container.innerHTML = renderHelpArticleProductCard(product);
        container.classList.remove('is-hidden');
    };
    HelpArticleInfoMain.prototype.loadHotContentSidebar = function () {
        var _this = this;
        var container = document.getElementById('help-hot-content');
        if (!container) {
            return;
        }
        this.bindHotContentShuffle(container);
        this.wmRequest
            .ajax({
            url: '/hotContentList',
            type: 'GET',
            data: { faq_limit: 15, course_limit: 15 },
        })
            .then(function (res) {
            var _a, _b;
            var body = res;
            if (!body || body.code !== 200 || !((_b = (_a = body.data) === null || _a === void 0 ? void 0 : _a.list) === null || _b === void 0 ? void 0 : _b.length)) {
                _this.hotContentPool = [];
                container.innerHTML = '<p class="help-hot-content__empty">暂无热门内容</p>';
                return;
            }
            _this.hotContentPool = body.data.list.filter(function (item) { return (item.article_url || '').trim() !== ''; });
            _this.renderHotContentSidebar(container);
        })
            .catch(function () {
            _this.hotContentPool = [];
            container.innerHTML = '<p class="help-hot-content__empty">加载失败，请稍后重试</p>';
        });
    };
    HelpArticleInfoMain.prototype.renderHotContentSidebar = function (container) {
        if (!this.hotContentPool.length) {
            container.innerHTML = '<p class="help-hot-content__empty">暂无热门内容</p>';
            return;
        }
        var displayCount = HelpArticleInfoMain.HOT_CONTENT_DISPLAY_COUNT;
        var picked = pickRandomHotContentItems(this.hotContentPool, displayCount);
        var showShuffle = this.hotContentPool.length > displayCount;
        var html = renderHelpHotContentCard(picked, { showShuffle: showShuffle });
        container.innerHTML = html || '<p class="help-hot-content__empty">暂无热门内容</p>';
    };
    HelpArticleInfoMain.prototype.bindHotContentShuffle = function (container) {
        var _this = this;
        if (this.hotContentShuffleBound) {
            return;
        }
        this.hotContentShuffleBound = true;
        container.addEventListener('click', function (event) {
            var target = event.target;
            var shuffleEl = target.closest('.help-hot-content-card__shuffle');
            if (!shuffleEl) {
                return;
            }
            event.preventDefault();
            if (!_this.hotContentPool.length) {
                return;
            }
            _this.renderHotContentSidebar(container);
        });
    };
    HelpArticleInfoMain.HOT_CONTENT_DISPLAY_COUNT = 5;
    return HelpArticleInfoMain;
}());
export default HelpArticleInfoMain;
